import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { decryptedAdminID } from "../../utility";
import axiosClient from "../../api/axiosClient";
import { getAdminIds } from "../../services/candidateServices";

const admin = Number(decryptedAdminID());

// ✅ BASE FILTER
const baseFilters = () => ({
  company_name: null,
  job_category: null,
  first_name: null,
  mobile_number: null,
  date_from: null,
  date_to: null,
  stage_id: null,
  sub_stage_id: null,
  limit: 10,
  offset: 0,
  admin_ids: admin ? [admin] : [],
  onlyMe: false,
});
// console.log("Base Filters 👉", baseFilters());
const normalizeValue = (val) => {
  if (val === null || val === undefined || val === "") return null;
  if (Array.isArray(val)) return val.length ? val : [];
  return val;
};
const isFilterDifferent = (filters) => {
  const defaultFilters = baseFilters();

  return Object.keys(defaultFilters).some((key) => {
    // ❌ Ignore system fields
    if (["limit", "offset", "admin_ids"].includes(key)) return false;

    let currentVal = normalizeValue(filters[key]);
    let defaultVal = normalizeValue(defaultFilters[key]);

    return JSON.stringify(currentVal) !== JSON.stringify(defaultVal);
  });
};
// console.log(isFilterDifferent,"isFilterDifferent");

// ✅ INITIAL STATE
const initialState = {
  filters: baseFilters(),
  isFilterActive: false, // 🔴 RED DOT STATE
  tableData: [],
  totalPages: 1,
  totalElements: 0,
  currentPage: 0,
  loading: false,
  error: null,
};

// ✅ DEBOUNCE
let debounceTimer;

const debounceApi = (fn, delay = 500) => {
  return (...args) =>
    new Promise((resolve, reject) => {
      if (debounceTimer) clearTimeout(debounceTimer);

      debounceTimer = setTimeout(async () => {
        try {
          const result = await fn(...args);
          resolve(result);
        } catch (err) {
          reject(err);
        }
      }, delay);
    });
};

const debouncedFetchInterviewApi = debounceApi(async (filters) => {
  const res = await axiosClient.post("/getInterviewFilter", filters);
  return res;
}, 500);

// ✅ FETCH INTERVIEWS
export const fetchInterviews = createAsyncThunk(
  "interview/fetchInterviews",
  async (_, { getState, rejectWithValue }) => {
    try {
      const { filters } = getState().interview;

      let updatedAdminIds = filters.admin_ids || [];

      // ✅ ONLY ME
      if (filters.onlyMe && updatedAdminIds.length === 1) {
        const res = await getAdminIds({
          id: updatedAdminIds[0],
          onlyMe: true,
        });

        updatedAdminIds =
          res?.data?.map((item) => item.admin_id) || [];
      }

      // ✅ TEAM LEADER
      else if (!filters.onlyMe && updatedAdminIds.length === 1) {
        const res = await getAdminIds({
          id: updatedAdminIds[0],
          onlyMe: false,
        });

        updatedAdminIds =
          res?.data?.map((item) => item.admin_id) || [];
      }

      const finalFilters = {
        ...filters,
        admin_ids: updatedAdminIds,
        
      };
    //   initialState.isFilterActive= isFilterDifferent(finalFilters);
      const cleanFilters = Object.fromEntries(
        Object.entries(finalFilters).filter(
          ([_, value]) =>
            value !== null &&
            value !== "" &&
            !(Array.isArray(value) && value.length === 0)
        )
      );

      // console.log("FINAL PAYLOAD 👉", cleanFilters);

      const res = await debouncedFetchInterviewApi(cleanFilters);

      return res.data;

    } catch (err) {
      return rejectWithValue(err.response?.data || "Error");
    }
  }
);

const interviewSlice = createSlice({
  name: "interview",
  initialState,

  reducers: {
    // updateInterviewFilter: (state, action) => {
    //   Object.assign(state.filters, action.payload);

    //   // 🔴 RED DOT UPDATE
    //   state.isFilterActive = isFilterDifferent(state.filters);
    // },

    updateInterviewFilter: (state, action) => {
  state.filters = {
    ...state.filters,
    ...action.payload,
  };

  state.isFilterActive = isFilterDifferent(state.filters);
},

    resetInterviewFilter: (state) => {
      state.filters = baseFilters();
      state.isFilterActive = false;
    },

    setInterviewPage: (state, action) => {
      const page = action.payload;

      state.currentPage = page;
      state.filters.offset = page * state.filters.limit;
    },
  },

  extraReducers: (builder) => {
    builder
      .addCase(fetchInterviews.pending, (state) => {
        state.loading = true;
      })

      .addCase(fetchInterviews.fulfilled, (state, action) => {
        state.loading = false;

        const data = action.payload?.data || {};

        state.tableData = data.content || [];
        state.totalPages = data.totalPages || 1;
        state.totalElements = data.totalElements || 0;
        state.currentPage = data.currentPage || 0;
      })

      .addCase(fetchInterviews.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export const {
  updateInterviewFilter,
  resetInterviewFilter,
  setInterviewPage,
} = interviewSlice.actions;

export default interviewSlice.reducer;